import { createTheme } from '@material-ui/core/styles'

const colors = {
  colors: {
    ui: {
      grey: '#939393',
      greyLight:'#EAEAEA',
      greenVeryLight:'#767676',
      greyDark: '#777777',
      greyVeryDark: '#333333',
      green: '#10B981',
      greenLight: '#ECFDF5',
      red:'#B91F26',
      redLight:'#FEF2F2',
      yellow:'#FFD800'
    },
  }
}

const theme = {
  palette: {
    primary: {
      main: colors.colors.ui.red,
    },
    saveButton: {
      main:'#F40B27',
    }
  },
  typography: {
    fontFamily: 'Verdana, Geneva, Tahoma, sans-serif', // fonte global MUI
  },

  overrides: {
    MuiCssBaseline: {
      '@global': {
        body: {
          fontFamily: 'Verdana, Geneva, Tahoma, sans-serif',
        },
      },
    },
    MuiDialog: {
      paper: {
        borderRadius: 15, 
      },
    },
    MuiButton: {
      root: {
        borderRadius: 15,
        // textTransform: 'none',
      },
    },
    MuiOutlinedInput: {
      root: { borderRadius: 15 },
      notchedOutline: { borderRadius: 15 },
    },
  },
  ...colors,
}

export const customTheme = createTheme(theme)